// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat Styles */
.chat-container {
  display: flex;
  height: calc(100vh - 120px);
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
}

.no-instance-selected {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  text-align: center;
}

.no-instance-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.no-instance-selected h3 {
  margin: 0 0 8px 0;
  color: #075E54;
  font-size: 24px;
}

.no-instance-selected p {
  margin: 0 0 32px 0;
  color: #666;
  font-size: 16px;
}

.available-instances h4 {
  margin: 0 0 16px 0;
  color: #075E54;
  font-size: 18px;
}

.instance-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 300px;
}

.instance-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  border: 2px solid #e0e0e0;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.instance-btn:hover {
  border-color: #25D366;
  background: #f0f8f0;
}

.instance-status {
  background: #28a745;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.chat-sidebar {
  width: 320px;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
}

.chat-header {
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
}

.chat-header h3 {
  margin: 0 0 4px 0;
  color: #075E54;
  font-size: 18px;
}

.instance-phone {
  color: #666;
  font-size: 14px;
}

.contacts-list {
  flex: 1 1;
  overflow-y: auto;
}

.no-contacts {
  padding: 40px 20px;
  text-align: center;
  color: #666;
}

.no-contacts p {
  margin: 0 0 8px 0;
  font-size: 16px;
}

.no-contacts small {
  font-size: 14px;
}

.contact-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border: none;
  background: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.3s ease;
}

.contact-item:hover {
  background: #f8f9fa;
}

.contact-item.active {
  background: #e8f5e8;
  border-right: 3px solid #25D366;
}

.contact-info {
  flex: 1 1;
  min-width: 0;
}

.contact-name {
  font-weight: 500;
  color: #075E54;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.last-message {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.message-time {
  font-size: 12px;
  color: #999;
}

.message-count {
  background: #25D366;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 12px;
  min-width: 18px;
  text-align: center;
}

.chat-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.no-chat-selected {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  text-align: center;
}

.no-chat-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.no-chat-selected h3 {
  margin: 0 0 8px 0;
  color: #075E54;
  font-size: 24px;
}

.no-chat-selected p {
  margin: 0;
  color: #666;
  font-size: 16px;
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.no-messages {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #666;
}

.no-messages p {
  margin: 0 0 8px 0;
  font-size: 16px;
}

.no-messages small {
  font-size: 14px;
}

.message {
  max-width: 70%;
  align-self: flex-start;
}

.message.sent {
  align-self: flex-end;
}

.message-content {
  background: #f1f1f1;
  padding: 8px 12px;
  border-radius: 12px;
  position: relative;
}

.message.sent .message-content {
  background: #dcf8c6;
}

.message-text {
  margin-bottom: 4px;
  word-wrap: break-word;
}

.message-time {
  font-size: 11px;
  color: #666;
  text-align: right;
}

.message-input {
  display: flex;
  padding: 16px;
  border-top: 1px solid #e0e0e0;
  gap: 8px;
}

.message-input input {
  flex: 1 1;
  padding: 10px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 24px;
  outline: none;
  font-size: 14px;
}

.message-input input:focus {
  border-color: #25D366;
}

.message-input button {
  background: #25D366;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.message-input button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .chat-container {
    flex-direction: column;
    height: calc(100vh - 100px);
  }
  
  .chat-sidebar {
    width: 100%;
    height: 40%;
  }
  
  .chat-main {
    height: 60%;
  }
}

@media (max-width: 640px) {
  .no-instance-selected {
    padding: 20px;
  }
  
  .instance-list {
    max-width: none;
  }
  
  .message {
    max-width: 85%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Chat Styles */\n.chat-container {\n  display: flex;\n  height: calc(100vh - 120px);\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.no-instance-selected {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n  text-align: center;\n}\n\n.no-instance-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.no-instance-selected h3 {\n  margin: 0 0 8px 0;\n  color: #075E54;\n  font-size: 24px;\n}\n\n.no-instance-selected p {\n  margin: 0 0 32px 0;\n  color: #666;\n  font-size: 16px;\n}\n\n.available-instances h4 {\n  margin: 0 0 16px 0;\n  color: #075E54;\n  font-size: 18px;\n}\n\n.instance-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  max-width: 300px;\n}\n\n.instance-btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f9fa;\n  border: 2px solid #e0e0e0;\n  padding: 12px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.instance-btn:hover {\n  border-color: #25D366;\n  background: #f0f8f0;\n}\n\n.instance-status {\n  background: #28a745;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n}\n\n.chat-sidebar {\n  width: 320px;\n  border-right: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-header {\n  padding: 16px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f9fa;\n}\n\n.chat-header h3 {\n  margin: 0 0 4px 0;\n  color: #075E54;\n  font-size: 18px;\n}\n\n.instance-phone {\n  color: #666;\n  font-size: 14px;\n}\n\n.contacts-list {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.no-contacts {\n  padding: 40px 20px;\n  text-align: center;\n  color: #666;\n}\n\n.no-contacts p {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n}\n\n.no-contacts small {\n  font-size: 14px;\n}\n\n.contact-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  border-bottom: 1px solid #f0f0f0;\n  transition: background-color 0.3s ease;\n}\n\n.contact-item:hover {\n  background: #f8f9fa;\n}\n\n.contact-item.active {\n  background: #e8f5e8;\n  border-right: 3px solid #25D366;\n}\n\n.contact-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.contact-name {\n  font-weight: 500;\n  color: #075E54;\n  margin-bottom: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.last-message {\n  font-size: 14px;\n  color: #666;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.contact-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.message-time {\n  font-size: 12px;\n  color: #999;\n}\n\n.message-count {\n  background: #25D366;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 12px;\n  min-width: 18px;\n  text-align: center;\n}\n\n.chat-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.no-chat-selected {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n  text-align: center;\n}\n\n.no-chat-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.no-chat-selected h3 {\n  margin: 0 0 8px 0;\n  color: #075E54;\n  font-size: 24px;\n}\n\n.no-chat-selected p {\n  margin: 0;\n  color: #666;\n  font-size: 16px;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.no-messages {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: #666;\n}\n\n.no-messages p {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n}\n\n.no-messages small {\n  font-size: 14px;\n}\n\n.message {\n  max-width: 70%;\n  align-self: flex-start;\n}\n\n.message.sent {\n  align-self: flex-end;\n}\n\n.message-content {\n  background: #f1f1f1;\n  padding: 8px 12px;\n  border-radius: 12px;\n  position: relative;\n}\n\n.message.sent .message-content {\n  background: #dcf8c6;\n}\n\n.message-text {\n  margin-bottom: 4px;\n  word-wrap: break-word;\n}\n\n.message-time {\n  font-size: 11px;\n  color: #666;\n  text-align: right;\n}\n\n.message-input {\n  display: flex;\n  padding: 16px;\n  border-top: 1px solid #e0e0e0;\n  gap: 8px;\n}\n\n.message-input input {\n  flex: 1;\n  padding: 10px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 24px;\n  outline: none;\n  font-size: 14px;\n}\n\n.message-input input:focus {\n  border-color: #25D366;\n}\n\n.message-input button {\n  background: #25D366;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.message-input button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .chat-container {\n    flex-direction: column;\n    height: calc(100vh - 100px);\n  }\n  \n  .chat-sidebar {\n    width: 100%;\n    height: 40%;\n  }\n  \n  .chat-main {\n    height: 60%;\n  }\n}\n\n@media (max-width: 640px) {\n  .no-instance-selected {\n    padding: 20px;\n  }\n  \n  .instance-list {\n    max-width: none;\n  }\n  \n  .message {\n    max-width: 85%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
